import React from 'react'
import Layout from '../layout/Layout'
import { Button, Col, Container, Row } from 'react-bootstrap'
import aboutImg from '../images/kvh-about.jpg'
import { Link } from 'react-router-dom'

export default function About() {


    return (

        <Container id='about'>

            <Row className='mt-5'>
                <Col md={6} className='text-center'>
                    <img src={aboutImg} alt='Krishna Velvet & Handloom' className='img-fluid' />
                </Col>
                <Col md={6} className='section-title'>
                    <div className="section-title position-relative my-4">
                        <h6 className="d-inline-block position-relative secondary-text text-uppercase pb-2">About Us</h6>

                    </div>
                    <p className='text-justify mt-5'>

                        We are a leading manufacturer and supplier of furnishing fabrics. Incepted in the year 2012 with an aim to offer high quality polyester fabric, today, we serve clients with the best and exceed their expectations.
                        <br />
                        <br />
                        We manufacture high-quality fabrics such as whiteout fabric, blackout fabric, Velvet fabric, Print Velvet, Plain Velvet, Knitting Fabric, jacquard Fabric  and many more that are used for designing cushion covers, curtains, bed covers and other textile made-ups.
                        <br />
                        <br />
                        We are well-equipped with a modern infrastructure base to meet the demands of the clients. Our talented and skilled team of professionals works under the management of our Founder, Mr. Mukeshbhai Kapopara, whose skills and knowledge about fabrics and fashion have always been a leading force.</p>

                    <div className='mt-4'>
                        <Button><Link className='text-light text-decoration-none' to='/about'>Read more</Link></Button>
                    </div>
                </Col>
            </Row>
        </Container>

    )
}
